import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import { AxiosResponse } from 'axios'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess3057SaveParamStatus: 'idle',
    startProcess3057SaveParamError: undefined as any,
    loadUserParamsProcess3057SaveParamStatus: 'idle',
    loadUserParamsProcess3057SaveParamError: undefined as any,
    bkIni_SprBKFlaecheStatus: 'idle',
    bkIni_SprBKFlaecheError: undefined as any,
    loadUserParamsProcess3057SaveParamTODOStatus: 'idle',
    loadUserParamsProcess3057SaveParamTODOError: undefined as any,

    process3057SaveParamList: [] as any[],
    bkIni_SprBKFlaeche: undefined as any,
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false
}

const prepParams = (url: string, globalFilters: any) => {
    const params: any = {}

    if (!url.includes('action=')) {
        params['action'] = 'gte'
    }

    if (globalFilters && (globalFilters.objectFilter || globalFilters.fromFilter)) {
        if (globalFilters.objectFilter) {
            params['MIN_ObjNr'] = globalFilters.objectFilter
            params['MAX_ObjNr'] = globalFilters.objectFilter
        }
    }

    return params
}

const getRespData = (res: AxiosResponse, rejectWithValue: Function | null, singleRes = false) => {
    let data: any = undefined
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            if (rejectWithValue) {
                throw rejectWithValue(parseMessages(res.data.messages))
            }
        } else {
            if (res.data.hasOwnProperty('data')) { // if the response conatins a data element then return it
                data = res.data.data
            } else { // if the response does not contain data element, the return response, but remove the status field
                data = _.omit(res.data, 'status')
            }
        }
    } else {  // backend response
        data = res.data
    }

    if (singleRes && data) {
        if (!data || (Array.isArray(data) && data.length === 0)) {
            if (rejectWithValue) {
                throw rejectWithValue('No data found')
            }
        } else {
            return Array.isArray(data) ? data[0] : data
        }
    } else {
        return data
    }
}

export const startProcess3057SaveParam = createAsyncThunk('process3057SaveParamSlice/startProcess3057SaveParam', async ({ process3057SaveParam }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess3057SaveParam/`,
        prepareData(process3057SaveParam),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
})

export const loadUserParamsProcess3057SaveParam = createAsyncThunk('process3057SaveParamSlice/loadUserParamsProcess3057SaveParam', async ({ globalFilters }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess3057SaveParam/?OBJNR=${globalFilters.objectFilter||'alle'}`,
        {
            params: prepParams(`/api/ixweb/LoadUserParamsProcess3057SaveParam/?OBJNR=${globalFilters.objectFilter||'alle'}`, globalFilters),
        }
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
})

export const bkIni_SprBKFlaeche = createAsyncThunk('process3057SaveParamSlice/bkIni_SprBKFlaeche', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/BkIni_SprBKFlaeche/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
})

export const loadUserParamsProcess3057SaveParamTODO = createAsyncThunk('process3057SaveParamSlice/loadUserParamsProcess3057SaveParamTODO', async ({ globalFilters }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess3057SaveParam/?OBJNR=${globalFilters.objectFilter||'alle'}`,
        {
            params: prepParams(`/api/ixweb/LoadUserParamsProcess3057SaveParam/?OBJNR=${globalFilters.objectFilter||'alle'}`, globalFilters),
        }
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
})

const Process3057SaveParamSlice = createSlice({
    name: 'process3057SaveParamSlice',
    initialState,
    reducers: {
        resetstartProcess3057SaveParam: (state) => {
            state.job = undefined
            state.startProcess3057SaveParamError = undefined
        },
        resetstartProcess3057SaveParamError: (state) => {
            state.startProcess3057SaveParamError = undefined
        },
        resetloadUserParamsProcess3057SaveParam: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess3057SaveParamError = undefined
        },
        resetloadUserParamsProcess3057SaveParamError: (state) => {
            state.loadUserParamsProcess3057SaveParamError = undefined
        },
        resetbkIni_SprBKFlaeche: (state) => {
            state.bkIni_SprBKFlaeche = undefined
            state.bkIni_SprBKFlaecheError = undefined
        },
        resetbkIni_SprBKFlaecheError: (state) => {
            state.bkIni_SprBKFlaecheError = undefined
        },
        resetloadUserParamsProcess3057SaveParamTODO: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess3057SaveParamTODOError = undefined
        },
        resetloadUserParamsProcess3057SaveParamTODOError: (state) => {
            state.loadUserParamsProcess3057SaveParamTODOError = undefined
        },
        removeFromProcess3057SaveParamListById: (state, action) => {
            state.process3057SaveParamList = state.process3057SaveParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess3057SaveParamListByIds: (state, action) => {
            state.process3057SaveParamList = state.process3057SaveParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        preloadData: (state, action) => {
            state.process3057SaveParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess3057SaveParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process3057SaveParamList = []
            state.startProcess3057SaveParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess3057SaveParam.pending, (state) => {
            state.startProcess3057SaveParamStatus = 'pending'
            state.startProcess3057SaveParamError = undefined
        })
        builder.addCase(startProcess3057SaveParam.fulfilled, (state, action) => {
            state.startProcess3057SaveParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess3057SaveParam.rejected, (state, action) => {
            state.startProcess3057SaveParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess3057SaveParamError = action.error.message
            } else {
                state.startProcess3057SaveParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess3057SaveParam.pending, (state) => {
            state.loadUserParamsProcess3057SaveParamStatus = 'pending'
            state.loadUserParamsProcess3057SaveParamError = undefined
        })
        builder.addCase(loadUserParamsProcess3057SaveParam.fulfilled, (state, action) => {
            state.loadUserParamsProcess3057SaveParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess3057SaveParam.rejected, (state, action) => {
            state.loadUserParamsProcess3057SaveParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess3057SaveParamError = action.error.message
            } else {
                state.loadUserParamsProcess3057SaveParamError = action.payload
            }
        })

        builder.addCase(bkIni_SprBKFlaeche.pending, (state) => {
            state.bkIni_SprBKFlaecheStatus = 'pending'
            state.bkIni_SprBKFlaecheError = undefined
        })
        builder.addCase(bkIni_SprBKFlaeche.fulfilled, (state, action) => {
            state.bkIni_SprBKFlaecheStatus = 'idle'

            {
                state.bkIni_SprBKFlaeche = action.payload

            }
        })
        builder.addCase(bkIni_SprBKFlaeche.rejected, (state, action) => {
            state.bkIni_SprBKFlaecheStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.bkIni_SprBKFlaecheError = action.error.message
            } else {
                state.bkIni_SprBKFlaecheError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess3057SaveParamTODO.pending, (state) => {
            state.loadUserParamsProcess3057SaveParamTODOStatus = 'pending'
            state.loadUserParamsProcess3057SaveParamTODOError = undefined
        })
        builder.addCase(loadUserParamsProcess3057SaveParamTODO.fulfilled, (state, action) => {
            state.loadUserParamsProcess3057SaveParamTODOStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess3057SaveParamTODO.rejected, (state, action) => {
            state.loadUserParamsProcess3057SaveParamTODOStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess3057SaveParamTODOError = action.error.message
            } else {
                state.loadUserParamsProcess3057SaveParamTODOError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess3057SaveParam,
    resetstartProcess3057SaveParamError,
    resetloadUserParamsProcess3057SaveParam,
    resetloadUserParamsProcess3057SaveParamError,
    resetbkIni_SprBKFlaeche,
    resetbkIni_SprBKFlaecheError,
    resetloadUserParamsProcess3057SaveParamTODO,
    resetloadUserParamsProcess3057SaveParamTODOError,
    removeFromProcess3057SaveParamListById,
    removeFromProcess3057SaveParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    preloadData,
    clearPreloadedData,
} = Process3057SaveParamSlice.actions
export default Process3057SaveParamSlice.reducer
